import React from "react";
import styled from "styled-components";

const LogoWrapper = styled.div<{ width: string; height: string }>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background-color: ${({ theme }) => theme.colors.teal};
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  box-shadow: 2px 2px 5px ${({ theme }) => theme.colors.textShadowDark};
`;

const LogoText = styled.span<{ fontSize: string }>`
  font-size: ${({ fontSize }) => fontSize};
  font-weight: 900;
  color: white;
  font-family: "Poppins", sans-serif;
  text-transform: lowercase;
`;

const NBLogo: React.FC<{
  width?: string;
  height?: string;
  fontSize?: string;
}> = ({ width = "56px", height = "56px", fontSize = "32px" }) => {
  return (
    <LogoWrapper width={width} height={height}>
      <LogoText fontSize={fontSize}>nb</LogoText>
    </LogoWrapper>
  );
};

export default NBLogo;
